<template>
  <div :class="$style.header">
    <img :class="$style.headerIcon" :src="yywI1" alt="" @click="router.push('/')" />
    <div :class="$style.headerNav1" @click="router.push('/')">首页</div>
    <div :class="$style.headerNav2" @click="router.push('/gamestore')">交易</div>
    <div :class="$style.headerNav2" @click="router.push('/zkGame')">史低游戏</div>
    <img :class="$style.headerNavIcon" :src="yywI2" alt="" />
    <div :class="$style.search">
      <div :class="$style.searchLeft">全部游戏</div>
      <div :class="$style.searchDir" />
      <a-auto-complete
        :value="searchGnameInput"
        :options="gameOptions"
        :filter-option="false"
        :default-active-first-option="false"
        @search="handleSearchGame"
        @select="handleSelectGame"
        @keydown="handleKeyDown"
      >
        <a-input
          :value="searchGnameInput"
          placeholder="请输入关键词查询"
          :class="$style.searchInput"
          allow-clear
          :bordered="false"
          @input="handleInput"
          @compositionstart="isComposing = true"
          @compositionend="handleCompositionEnd"
        />
      </a-auto-complete>
      <a-button
        :class="$style.searchBtn"
        type="primary"
        :icon="createSearchIcon()"
        @click="onClicksearch"
      >
        搜索
      </a-button>
    </div>
    <div :class="$style.buyBtn" @click="router.push('/gamestore')">
      <img :class="$style.buyBtnI" :src="yywI4" alt="" />
      <span :class="$style.buyBtnT">我要买</span>
    </div>
    <div :class="$style.sellBtn" @click="$openInNewTab('/profile/account')">
      <img :class="$style.sellBtnI" :src="yywI5" alt="" />
      <span :class="$style.sellBtnT">成为卖家</span>
    </div>
    <template v-if="isAuthenticated">
      <div
        :class="$style.loginOutBtn"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <img :class="$style.loginOutBtnI" :src="yywI6" alt="" @click="gotoProfile" />
        <div
          v-if="isShowLoginOut"
          :class="$style.loginOutBtnP"
          @mouseleave="handlePanelMouseLeave"
          @mouseenter="handlePanelMouseEnter"
        >
          <div :class="$style.loginOutBtnPT">
            {{ userinfo?.username || "-" }}
          </div>
          <div :class="$style.loginOutBtnPBB" @click="$openInNewTab('/profile/')">
            进入个人中心
          </div>

          <div :class="$style.loginOutBtnPB" @click="handleLogout">
            <img :class="$style.loginOutBtnPBI" :src="yywI35" alt="" />
            <div>退出</div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!isAuthenticated">
      <div :class="$style.loginBtn" @click="navigateToLogin">
        <img :class="$style.loginBtnI" :src="yywI6" alt="" />
        <span :class="$style.loginBtnT">登录</span>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, h, useCssModule, onMounted } from "vue";
import axios from "@/axios";
import { useStore } from "vuex";
import { useRouter } from 'vue-router'
import yywI1 from "@assets/image/yywI1.png";
import yywI2 from "@assets/image/yywI2.png";
import yywI3 from "@assets/image/yywI3.png";
import yywI4 from "@assets/image/yywI4.png";
import yywI5 from "@assets/image/yywI5.png";
import yywI6 from "@assets/image/yywI6.png";
import yywI35 from "@assets/image/yywI35.png";

const router = useRouter();
const store = useStore();
const styles = useCssModule();
const searchGnameInput = computed(() => store.state.searchGnameInput);
const isAuthenticated = computed(() => store.state.auth.isAuthenticated);
const userinfo = computed(() => store.state.user.user);
const gameOptions = ref([]);
const originalGameOptions = ref([]);
const isComposing = ref(false);
const isShowLoginOut = ref(false);
const isMouseOnPanel = ref(false);

const createSearchIcon = () => {
  return h("img", {
    src: yywI3,
    class: {
      [styles.wbSearchIcon]: true,
    },
  });
};

// 页面挂载时初始化游戏选项
onMounted(() => {
  fetchGameData();
});

// 节流处理，避免频繁请求
const fetchGameData = async () => {
  const res = await axios.post("web/get_game_enum_v2/", {}).catch(() => {});
  if (res?.data?.status === 10000) {
    originalGameOptions.value = res?.data?.data?.map((item) => ({
      value: item,
      label: item,
    }));
  }
};

// 本地模糊搜索
const handleSearchGame = (val) => {
  const searchValue = val.toLowerCase(); // 转为小写以实现大小写不敏感搜索
  if (!searchValue) {
    gameOptions.value = [];
    return;
  }
  gameOptions.value = originalGameOptions.value.filter((item) =>
    item.label.toLowerCase().includes(searchValue)
  );
};

// 当选择一个游戏时，清空 SKU 并加载对应的 SKU 数据
const handleSelectGame = (val) => {
  store.dispatch("setSearchGname", val || "");
  router.push(`/gameStore?search_name=${val}`);
};

// 游戏搜索
const handleKeyDown = (event) => {
  if (event.key === "Enter") {
    store.dispatch("setSearchGname", searchGnameInput.value);
    router.push(`/gameStore?search_name=${searchGnameInput.value}`);
  }
};

const gotoProfile = () => {
  window.open('/profile', '_blank')
}

const handleInput = (event) => {
  if (isComposing.value) {
    return; // 如果正在组合输入，忽略 handleInput 的处理
  }
  store.commit("SET_SEARCHGNAMEINPUT", event.target.value || "");
  handleSearchGame(event.target.value);
};

const handleCompositionEnd = (event) => {
  isComposing.value = false; // 输入法结束
  handleInput(event);
};

const onClicksearch = () => {
  store.dispatch("setSearchGname", searchGnameInput.value);
  router.push(`/gameStore?search_name=${searchGnameInput.value}`);
};

// 导航到登录页面
const navigateToLogin = () => {
  // store.commit("SET_LOGINMODALTYPE", "login");
  // store.dispatch("authModal/showLoginModal");
  router.push("/login");
};

// 处理登出
const handleLogout = async () => {
  try {
    await store.dispatch("logout");
    router.push('/gameStore');
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

const handleMouseEnter = () => {
  isShowLoginOut.value = true;
  isMouseOnPanel.value = false;
};

const handleMouseLeave = () => {
  // 添加延迟，确保鼠标有时间进入面板
  setTimeout(() => {
    if (!isMouseOnPanel.value) {
      isShowLoginOut.value = false;
    }
  }, 100);
};

const handlePanelMouseEnter = () => {
  isMouseOnPanel.value = true;
};

const handlePanelMouseLeave = () => {
  isMouseOnPanel.value = false;
  isShowLoginOut.value = false;
};
</script>

<style module>
.header {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.headerIcon {
  width: 140px;
  height: 54px;
  align-self: flex-start;
  margin-top: 10px;
  cursor: pointer;
}
.headerNav1 {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-left: 70px;
  cursor: pointer;
}
.headerNav2 {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-left: 30px;
  cursor: pointer;
}
.headerNavIcon {
  width: 40px;
  height: 14px;
  margin-left: 10px;
}
.search {
  margin-left: 42px;
  width: 900px;
  height: 44px;
  border: 2px solid #ff942e;
  border-radius: 22px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.searchLeft {
  width: 96px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.searchDir {
  height: 14px;
  width: 1.5px;
  background-color: #afafaf;
  margin-right: 20px;
}
.searchInput {
  height: 40px;
  font-size: 14px;
  color: #999999;
  font-weight: 400;
}
.searchBtn {
  height: 36px;
  width: 90px;
  font-size: 14px;
  border-radius: 20px;
  font-weight: 500;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: 2px;
  background-color: #ff942e !important;
  border-color: #ff942e !important;
}
.searchBtn:hover {
  background-color: #ff942e !important;
}
.wbSearchIcon {
  width: 16px;
  height: 16px;
  margin-right: 13px;
}
.buyBtn {
  margin-left: 90px;
  width: 90px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #f9a607;
  cursor: pointer;
}
.buyBtnI {
  width: 14px;
  height: 14px;
  margin-left: 12px;
}
.buyBtnT {
  color: #ff942e;
  font-weight: 500;
  font-size: 14px;
  margin-left: 6px;
}
.sellBtn {
  margin-left: 20px;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #59afff;
  cursor: pointer;
}
.sellBtnI {
  width: 14px;
  height: 14px;
  margin-left: 12px;
}
.sellBtnT {
  color: #59afff;
  font-weight: 500;
  font-size: 14px;
  margin-left: 6px;
}
.loginBtn {
  margin-left: 10px;
  width: 80px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  background-color: #ff942e;
  cursor: pointer;
}
.loginBtnI {
  width: 14px;
  height: 14px;
  margin-left: 12px;
}
.loginBtnT {
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}
.loginOutBtn {
  margin-left: 10px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: #ff942e;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}
.loginOutBtnI {
  width: 14px;
  height: 14px;
}
.loginOutBtnP {
  position: absolute;
  top: 50px;
  left: 0;
  width: 140px;
  height: 84px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
}
.loginOutBtnPT {
  margin: 10px 0 10px 10px;
  font-family: "DINAlternate-Bold";
  color: #666666;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
}
.loginOutBtnPBB {
  margin: 10px 0 10px 10px;
  display: flex;
  align-items: center;
  color: #666666;
  font-weight: 500;
  font-size: 14px;
}
.loginOutBtnPB {
  margin-left: 10px;
  display: flex;
  align-items: center;
  color: #666666;
  font-weight: 500;
  font-size: 14px;
}
.loginOutBtnPBI {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}
</style>

<style scoped>
:deep .ant-input {
  width: 650px;
}
</style>